import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Switch, Radiobuttons } from 'components';

import {
  getProductInfoBySlotName,
  getSystemObjectProperties,
  getSystemObjectAccessories,
  setSystemObjectPropertyValue,
  getSystemObjectPropertyValue,
  addAccessory,
  removeAccessory,
  findOptionIndex,
  canExcludeFromQuote,

  getProductName,
  getProductBrandName,
  hasProductDescription,

  getIdOfAccessorySet,
  getAccessoriesOfProductData,
  AccessoryCategory,
} from 'utils/project-definition/component';

import {
  getComponentType,
} from 'utils/project-definition/project-definition-data-access';

import componentOptionPanels from './component-options-panels';

export default class ConfigOptionsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.changeExcludeFromQuoteHandler = this.changeExcludeFromQuoteHandler.bind(this);
    this.propertyChangedHandler = this.propertyChangedHandler.bind(this);
    this.itemPropertyChangedHandler = this.itemPropertyChangedHandler.bind(this);
    this.closeHandler = this.closeHandler.bind(this);
    this.clickPropertyInfoHandler = this.clickPropertyInfoHandler.bind(this);
    this.clickOptionInfoHandler = this.clickOptionInfoHandler.bind(this);
    this.clickProductInfoHandler = this.clickProductInfoHandler.bind(this);
    this.renderOptionSet = this.renderOptionSet.bind(this);

    this.state = {
      open: props.open,
    };
  }

  componentWillReceiveProps(props) {
    const { open } = props;
    this.setState({ open });
  }

  /* event handlers */

  clickProductInfoHandler(evt) {
    evt.preventDefault();
    const { onClickProductInfo } = this.props;
    if (onClickProductInfo) {
      const {
        product,
        systemProducts,
        systemDefinition,
        systemDefinitionSlotName,
      } = this.props;

      onClickProductInfo(
        product,
        systemDefinitionSlotName,
        systemDefinition,
        systemProducts,
        this,
        evt,
      );
    }
    return false;
  }

  clickPropertyInfoHandler(property, evt) {
    // TODO: show property info
    evt.preventDefault();  // Prevent selecting this property

    const { onClickPropertyInfo } = this.props;
    if (onClickPropertyInfo) {
      onClickPropertyInfo(property, this, evt);
    }
    return false;
  }

  clickOptionInfoHandler(option, evt) {
    // TODO: show property info
    const { onClickOptionInfo } = this.props;
    if (onClickOptionInfo) {
      onClickOptionInfo(option, this, evt);
    }
  }

  closeHandler() {
    this.setState({ open: false });
    const { onClose } = this.props;
    if (onClose) {
      onClose();
    }
  }

  propertyChangedHandler(value) {
    const data = this.getProductData();

    const {
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      onChangedProperty,
    } = this.props;

    setSystemObjectPropertyValue(systemDefinitionSlotName, value, systemDefinition, systemProducts);

    // data.property = value;
    if (onChangedProperty) {
      onChangedProperty(value, data, systemDefinitionSlotName, systemDefinition, systemProducts, this);
    }
  }

  itemPropertyChangedHandler(name, value) {
    const data = this.getProductData();

    const {
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      onChangedItemProperty,
    } = this.props;

    // data.property = value;
    if (onChangedItemProperty) {
      onChangedItemProperty(name, value, data, systemDefinitionSlotName, systemDefinition, systemProducts, this);
    }
  }

  changeExcludeFromQuoteHandler(value) {
    const data = this.getProductData();
    const { onToggledExcludeFromQuote, systemDefinitionSlotName } = this.props;

    this.setExcludePrice(value);
    if (onToggledExcludeFromQuote) {
      onToggledExcludeFromQuote(value, data, systemDefinitionSlotName, this);
    }
  }

  /* methods */

  getProductData() {
    const { systemDefinition, systemDefinitionSlotName } = this.props;
    if (systemDefinition && systemDefinitionSlotName) {
      const { attributes } = systemDefinition;
      if (!attributes) {
        return null;
      }
      const { slots } = attributes;
      if (!slots) {
        return null;
      }
      return slots[systemDefinitionSlotName];
    }
    return null;
  }

  getProductId() {
    const data = this.getProductData();
    if (!data) {
      return null;
    }
    return data.id;
  }

  isShown() {
    const { open } = this.state;
    const {
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;

    return open &&
      !!systemDefinitionSlotName &&
      !!systemDefinition &&
      !!systemProducts;
  }

  // signatures:
  // hasOption({ id: 123, model: 'product'/'accessory' })
  // hasOption(123, 'product'/'accessory')
  hasOption(option) {
    return this.getOptionIndex(option) >= 0;
  }

  // signatures:
  // getOptionIndex({ id: 123, model: 'product'/'accessory' })
  // getOptionIndex(123, 'product'/'accessory')
  getOptionIndex(option) {
    const {
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;
    return findOptionIndex(
      option,
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    );
  }

  setOption(option, value) {
    const {
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;
    if (value) {
      addAccessory(systemDefinitionSlotName, option, systemDefinition, systemProducts);
    } else {
      removeAccessory(systemDefinitionSlotName, option, systemDefinition, systemProducts);
    }
    /*
    const data = this.getProductData();
    if (!data) {
      return;
    }
    let { options } = data;
    const idx = this.getOptionIndex(option);

    if (value && idx < 0) {
      if (!options) {
        options = [];
      }
      const { id, amount } = option;
      options.push({ id, amount, type: option.model_type });
      data.options = options;
    } else if (!value && idx >= 0 && options) {
      options.splice(idx, 1);
    }
    */
  }

  setExcludePrice(value) {
    const data = this.getProductData();

    data.exclude_price = value;
  }

  /* render */

  // Add rendered results to array

  addExcludeFromQuoteRender(array) {
    const {
      disabled,
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;
    if (!canExcludeFromQuote(systemDefinitionSlotName, systemDefinition, systemProducts)) {
      return;
    }
    if (systemDefinitionSlotName === 'external_unit') {
      return;
    }

    const data = this.getProductData();
    const excludePrice = data ? data.exclude_price : false;
    const productId = this.getProductId();
    const className = classnames(
      'configurator-options-panel__item ',
      'config-option-item',
    );
    array.push(
      <div key={`section-${productId}-exclude-from-quote`} className={className}>
        <Switch
          disabled={disabled}
          value={excludePrice}
          label="configurator.productSettings.excludeFromQuote"
          onChange={this.changeExcludeFromQuoteHandler}
        />
      </div>,
    );
  }

  addPropertyRenders(array) {
    const { disabled, systemDefinitionSlotName, systemDefinition, systemProducts, product } = this.props;
    // const { properties } = product;
    if (!systemDefinitionSlotName) {
      return;
    }
    const properties = getSystemObjectProperties(systemDefinitionSlotName, systemDefinition, systemProducts, product);
    const numProperties = properties ? properties.length : 0;
    if (!numProperties) {
      return;
    }

    const productId = this.getProductId();

    array.push(
      <div
        key={`section-${productId}-property`}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'config-option-item__title-container',
          )
        }
      >
        <FormattedMessage id="configurator.productSettings.properties" />
      </div>,
    );
    const propertyElements = [];
    for (let i = 0; i < numProperties; i += 1) {
      const property = properties[i];
      if (property) {
        let propertyLabel = property;
        let propertyValue = property;
        if (property && typeof (property) === 'object') {
          const labelKey = property.labelKey;
          propertyValue = property.value;
          if (labelKey) {
            propertyLabel = (
              <FormattedMessage id={labelKey} />
            );
          } else {
            propertyLabel = property.label || property.value;
          }
        }

        let infoButton = null;

        // TODO: Enable info buttons as soon as property info is available
        const tempDisablePropertyInfo = true;
        if (!tempDisablePropertyInfo) {
          const onClickPropertyInfo = (evt) => {
            return this.clickPropertyInfoHandler(property, evt);
          };
          infoButton = this.renderInfoButton(onClickPropertyInfo);
        }
        // Property sometimes number, Radiobuttons component expects strings
        if (typeof (propertyValue) === 'number') {
          propertyValue = `${propertyValue}`;
        }

        propertyElements.push(
          {
            id: propertyValue,
            value: propertyValue,
            data: property,
            label: (
              <div className="align align--fluid">
                <div className="align__row">
                  <div className="align__cell">
                    {propertyLabel}
                  </div>
                  <div className="align__cell align__cell--shrink">
                    {infoButton}
                  </div>
                </div>
              </div>
            ),
          },
        );
      }
    }

    // const data = this.getProductData();

    let selectedProperty = getSystemObjectPropertyValue(systemDefinitionSlotName, systemDefinition, systemProducts);

    // Property sometimes number, Radiobuttons component expects strings
    if (typeof (selectedProperty) === 'number') {
      selectedProperty = `${selectedProperty}`;
    }
    if (typeof (selectedProperty) !== 'string') {
      // Sometimes I get an array as property. Should be a string
      selectedProperty = '';
    }

    array.push(
      <div
        key={`section-${productId}-properties`}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'configurator-options-panel__properties-list',
          )
        }
      >
        <Radiobuttons
          disabled={disabled}
          onChange={this.propertyChangedHandler}
          selected={selectedProperty}
          values={propertyElements}
        />
      </div>,
    );
  }

  //--
  // Deprecated
  addOptionRender(item, index, length, useOptionalOption, sourceArray, destArray) {
    if (useOptionalOption) {
      this.addOptionalOptionRender(item, index, length, useOptionalOption, sourceArray, destArray);
      return;
    }
    this.addRegularOptionRender(item, index, length, useOptionalOption, sourceArray, destArray);
  }

  isOptionSetRequired(optionSet) {
    if (optionSet) {
      return false;
    }
    return false;
  }

    /*
    Add
      attributes: {
        options: [
          { id: ..., type: ... set: "..."}
        ]
      }
  */
  getOptionSetValue(optionSet) {
    if (optionSet) {
      const { systemDefinition, systemDefinitionSlotName } = this.props;
      const setEntryId = optionSet.set_entry_id;
      const productData = systemDefinition.attributes.slots[systemDefinitionSlotName];
      const { options } = productData;
      const numOptions = options ? options.length : 0;
      if (!numOptions) {
        return false;
      }
      // TODO: optimize this if possible and if I still have some courage to do that
      for (let i = 0; i < numOptions; i += 1) {
        const opt = options[i];
        const optSet = opt ? opt.set : null;
        if (optSet === setEntryId) {
          return true;
        }
      }
      return false;
    }
    return false;
  }

  removeOptionSets() {
    const { systemDefinition, systemDefinitionSlotName, systemProducts } = this.props;
    const productInfo = getProductInfoBySlotName(systemDefinitionSlotName, systemDefinition, systemProducts);
    if (!productInfo) {
      return;
    }
    const accessoryCollections = getAccessoriesOfProductData(productInfo, AccessoryCategory.ACCESSORY_COLLECTIONS);
    const accessorySetKeys = accessoryCollections ? Object.keys(accessoryCollections) : null;
    const numAccessorySetKeys = accessorySetKeys ? accessorySetKeys.length : 0;

    for (let j = 0; j < numAccessorySetKeys; j += 1) {
      const key = accessorySetKeys[j];
      const accessoryCollection = accessoryCollections[key];
      const accessories = accessoryCollection ? accessoryCollection.sets : null;
      const numAccessories = accessories ? accessories.length : 0;
      for (let i = 0; i < numAccessories; i += 1) {
        const accessorySet = accessories[i];
        const accessorySetId = getIdOfAccessorySet(accessorySet);
        if (accessorySet && accessorySetId) {
          this.removeOptionSet(accessorySetId);
        }
      }
    }
  }

  removeOptionSet(id) {
    const { systemDefinition, systemDefinitionSlotName } = this.props;
    const productData = systemDefinition.attributes.slots[systemDefinitionSlotName];
    const { options } = productData;
    const numOptions = options ? options.length : 0;
    if (!numOptions) {
      return;
    }
    for (let i = numOptions - 1; i >= 0; i -= 1) {
      const opt = options[i];
      if (opt.set && opt.set === id) {
        options.splice(i, 1);
      }
    }
  }

  addOptionSet(optionSet) {
    const { systemDefinition, systemDefinitionSlotName } = this.props;
    const productData = systemDefinition.attributes.slots[systemDefinitionSlotName];
    const optionsArray = productData.options || [];
    productData.options = optionsArray;

    const { set } = optionSet;
    const setEntryId = optionSet.set_entry_id;
    set.forEach((item) => {
      optionsArray.push({
        id: item.id,
        set: setEntryId,
        amount: item.amount,
        type: item.model_type,
      });
    });
  }

  clearOptionSetsOfOptionsGroup(key) {
    if (!key) {
      return;
    }
    const {
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;

    if (!systemDefinition || !systemProducts || !systemDefinitionSlotName) {
      return;
    }
    const productData = systemDefinition.attributes.slots[systemDefinitionSlotName];
    const optionsArray = productData ? productData.options : null;
    const numOptions = optionsArray ? optionsArray.length : 0;

    for (let i = numOptions - 1; i >= 0; i -= 1) {
      const option = optionsArray[i];
      const optionSet = option ? option.set : null;
      if (optionSet && optionSet.includes('-')) {
        const parts = optionSet.split('-');
        parts.pop();
        const optionGroupKey = parts.join('-');
        if (key === optionGroupKey) {
          optionsArray.splice(i, 1);
        }
      }
    }
  }

  addOptionalOptionRender(
    item,
    index,
    length,
    useOptionalOption,
    sourceArray,
    destArray,
    optionGroupKey,

    // One value should be on (sort-of required)
    // If true, it's not allowed to toggle off a switch that is already on
    // (Selecting another switch in the same group is the only way to toggle this one off)
    needsOneValueSet = false,
  ) {
    const key = getIdOfAccessorySet(item);
    // const required = this.isOptionSetRequired(item);
    const value = this.getOptionSetValue(item);

    // Disable if:
    // - this panel is disabled (this.props.disabled)
    // - The value of this option is true and
    //   there should be one item on in the same group
    //   Turning this item off would then cause no items to be selected
    const optionDisabled = (value && needsOneValueSet) || this.props.disabled;

    const onToggle = (newValue) => {
      this.clearOptionSetsOfOptionsGroup(optionGroupKey);
      if (newValue) {
        this.addOptionSet(item);
      }

      const {
        onToggledOption,
        systemDefinitionSlotName,
        systemDefinition,
        systemProducts,
        product,
      } = this.props;

      const data = this.getProductData();

      if (onToggledOption) {
        onToggledOption(
          newValue,
          item,
          data,
          systemDefinitionSlotName,
          systemDefinition,
          systemProducts,
          product,
          this,
        );
      }

      this.forceUpdate();
    };
    destArray.push(
      // Render one switch with one or more accessory product descriptions
      this.renderSwitch(item, key, value, onToggle, optionDisabled, this.renderOptionSet, true),
    );
    /*
    const { id, image, required } = item;
    const prodId = product ? product.id : null;
    const key = `option-${id}_product-${prodId}`;
    const { onToggledOption, product, disabled } = this.props;
    const optionDisabled = required || disabled;

    destArray.push(
      this.renderSwitch(item, key, value, onToggledOption, optionDisabled, contentCallback),
    );
    */
  }

  isOptionRequired(item, index, length, useOptionalOption) {
    if (!item) {
      return false;
    }
    const utils = this.getUtilsBySlotName();
    if (utils && utils.isOptionRequired) {
      const res = utils.isOptionRequired(item, index, length, useOptionalOption);
      if (typeof (res) === 'boolean') {
        return res;
      }
    }
    return item.required;
  }

  addRegularOptionRender(item, index, length, useOptionalOption, sourceArray, destArray) {
    const data = this.getProductData();
    const { id, image } = item;

    const required = this.isOptionRequired(item, index, length, useOptionalOption);

    const {
      onToggledOption,
      product,
      disabled,
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;
    const prodId = product ? product.id : null;

    const key = `option-${id}_product-${prodId}`;

    const hasOption = required || this.hasOption(item);
    let optionDisabled = required || disabled;
    if (typeof (optionDisabled) === 'number') {
      // Sometimes 'required' is a number (1/0 instead of true/false)
      optionDisabled = optionDisabled > 0;
    }

    const toggleOptionHandler = (flag) => {
      this.setOption(item, flag);
      if (onToggledOption) {
        onToggledOption(
          flag,
          item,
          data,
          systemDefinitionSlotName,
          systemDefinition,
          systemProducts,
          product,
          this,
        );
      }
    };

    const imgStyle = {
      backgroundImage: `url(${image})`,
    };

    const clickOptionInfoHandler = (evt) => {
      this.clickOptionInfoHandler(item, evt);
    };

    destArray.push(
      <div
        key={key}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'config-accessory-item',
          )
        }
      >
        <div className="align align--fluid">
          <div className="align__row">
            <div className="align__cell align__cell--shrink config-option-item__switch">
              <Switch
                disabled={optionDisabled}
                value={hasOption}
                onChange={toggleOptionHandler}
              />
            </div>
            <div className="align__cell align__cell--shrink">
              <div
                style={imgStyle}
                className="config-option-item__image-container"
              />
            </div>
            <div className="align__cell">
              <div className="config-option-item__title-container">
                <div className="config-option-item__title">{item.name}</div>
                <div className="config-option-item__brand">{item.brand}</div>
                <div className="config-option-item__brand">{item.chapter}</div>
              </div>
            </div>
            <div className="align__cell align__cell--shrink">
              {this.renderInfoButton(clickOptionInfoHandler)}
            </div>
          </div>
        </div>
      </div>,
    );
  }

  renderSwitch(item, key, value, changeHandler, disabled, contentCallback, multilineContent) {
    const content = contentCallback ? contentCallback(item) : null;
    /*
    const toggleOptionHandler = (flag) => {
      this.setOption(item, flag);
      if (changeHandler) {
        changeHandler(flag, item, this.getProductData(), this.props.product, this);
      }
    };
    */
    const cellClassNames = classnames(
      'align__cell',
      'align__cell--shrink',
      'config-option-item__switch',
      { 'config-option-item__switch--multiline-content': multilineContent },
    );

    return (
      <div
        key={key}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'config-accessory-item',
          )
        }
      >
        <div className="align align--fluid">
          <div className="align__row">
            <div className={cellClassNames}>
              <Switch
                disabled={disabled}
                value={value}
                onChange={changeHandler}
              />
            </div>
            { content }
          </div>
        </div>
      </div>
    );
  }

  renderOptionSet(optionSet) {
    const options = optionSet.set;
    const setId = getIdOfAccessorySet(optionSet);
    const elements = options.map((data) => {
      const optionId = `${data.id}`;
      const key = `${setId}_${optionId}`;
      return (
        <div key={key} className="config-option-item__product-data">
          {this.renderOptionData(data)}
        </div>
      );
    });
    return (
      <div>
        { elements }
      </div>
    );
  }

  renderOptionData(item) {
    const { image } = item;
    const imgStyle = {
      backgroundImage: `url(${image})`,
    };

    const clickOptionInfoHandler = (evt) => {
      this.clickOptionInfoHandler(item, evt);
    };

    const key = `${item.id}`;

    return (
      <div key={key}>
        <div className="align__cell align__cell--shrink">
          <div
            style={imgStyle}
            className="config-option-item__image-container"
          />
        </div>
        <div className="align__cell">
          <div className="config-option-item__title-container">
            <div className="config-option-item__title">{item.name}</div>
            <div className="config-option-item__brand">{item.brand}</div>
          </div>
        </div>
        <div className="align__cell align__cell--shrink">
          {this.renderInfoButton(clickOptionInfoHandler)}
        </div>
      </div>
    );
  }

  addOptionRenders(array) {
    const {
      product,
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
    } = this.props;

    if (!systemDefinitionSlotName || !systemDefinition || !systemProducts) {
      return;
    }

    const accessories = getSystemObjectAccessories(
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      product,
      false,
    );
    const accessoryCollections = getSystemObjectAccessories(
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      product,
      true,
    );
    const numAccessories = accessories ? accessories.length : 0;
    const optionalAccessoryKeys = accessoryCollections ? Object.keys(accessoryCollections) : null;
    const numOptionalAccessoryKeys = optionalAccessoryKeys ? optionalAccessoryKeys.length : 0;
    if (!numAccessories && !numOptionalAccessoryKeys) {
      return;
    }

    const productId = product ? product.id : '';

    array.push(
      <div
        key={`section-${productId}-${systemDefinitionSlotName || ''}-options`}
        className={
          classnames(
            'configurator-options-panel__item',
            'config-option-item',
            'config-option-item__title-container',
          )
        }
      >
        <FormattedMessage id="configurator.productSettings.options" />
      </div>,
    );

    for (let i = 0; i < numAccessories; i += 1) {
      this.addRegularOptionRender(accessories[i], i, numAccessories, false, accessories, array);
    }
    for (let i = 0; i < numOptionalAccessoryKeys; i += 1) {
      const key = optionalAccessoryKeys[i];
      const accessoryCollection = accessoryCollections[key];
      const accessoryCollectionSets = accessoryCollection ? accessoryCollection.sets : null;
      const required = accessoryCollection ? !!accessoryCollection.required : false;
      const numAccessoryCollectionSets = accessoryCollectionSets ? accessoryCollectionSets.length : 0;

      this.renderAccessorySeparator(array, `optionalaccessories-${i}`);
      for (let j = 0; j < numAccessoryCollectionSets; j += 1) {
        this.addOptionalOptionRender(
          accessoryCollectionSets[j],
          j,
          numAccessoryCollectionSets,
          true,
          accessoryCollectionSets,
          array,
          key,
          required,
        );
      }
    }
  }

  renderAccessorySeparator(array, key) {
    const sepKey = `separator-${key}`;
    array.push(
      <div key={sepKey} className="config-option-separator" />,
    );
  }

  renderInfoButton(handler) {
    return (
      <div
        className="configurator-options-panel__info-button"
        onClick={handler}
        role="button"
      >
        <span className="icon-info icon--lg" />
      </div>
    );
  }

  renderCloseButton() {
    return (
      <div
        className="configurator-options-panel__close-button"
        onClick={this.closeHandler}
        role="button"
      >
        <span className="icon-close icon--xs" />
      </div>
    );
  }

  renderHeader() {
    const {
      product,
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      intl,
    } = this.props;

    const name = getProductName(
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      product,
      intl,
    );

    const brand = getProductBrandName(
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      product,
      intl,
    );

    let infoButton = null;
    const hasDescr = hasProductDescription(
      systemDefinitionSlotName,
      systemDefinition,
      systemProducts,
      product,
    );
    if (hasDescr) {
      infoButton = this.renderInfoButton(this.clickProductInfoHandler);
    }

    return (
      <div className="configurator-options-panel__product-title-container" >
        {this.renderCloseButton()}
        <div className="configurator-options-panel__item">
          <div className="align align--fluid">
            <div className="align__row">
              <div className="align__cell">
                <div className="configurator-options-panel__product-title">{name}</div>
                <div className="configurator-options-panel__product-brand">{brand}</div>
              </div>
              <div className="align__cell align__cell--shrink">
                {infoButton}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    const result = [];

    this.addExcludeFromQuoteRender(result);
    this.addComponentTypePropertyRenders('first', result);
    this.addPropertyRenders(result);

    this.addComponentTypePropertyRenders('middle', result);

    this.addOptionRenders(result);
    this.addComponentTypePropertyRenders('last', result);

    return result;
  }

  getUtilsBySlotName(slotName = null) {
    const sn = slotName || this.props.systemDefinitionSlotName;
    const componentType = getComponentType(sn);
    const typeName = componentType ? componentType.type || sn : sn;

    return componentOptionPanels[typeName];
  }

  addComponentTypePropertyRenders(panelLocation, resultArray) {
    const slotName = this.props.systemDefinitionSlotName;

    const utils = this.getUtilsBySlotName(slotName);
    if (!utils || !utils.addComponentTypePropertyRenders) {
      return;
    }

    utils.addComponentTypePropertyRenders(
      slotName,
      this.props.systemDefinition,
      this.props.systemProducts,
      this.props.product,
      this,
      panelLocation,
      resultArray,
    );
  }

  render() {
    const isShown = this.isShown();

    const className = classnames(
      'configurator-options-panel',
      {
        'is-open': isShown,
      },
    );

    return (
      <div className={className}>
        <div className="align align--fluid align--full-height">
          <div className="align__row align__row--shrink">
            <div className="align__cell">
              {this.renderHeader()}
            </div>
          </div>
          <div className="align__row" style={{ height: '100%' }}>
            <div className="align__cell align__cell--grow configurator-options-panel__options-cell">
              <div className="configurator-options-panel__options-container">
                {this.renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

ConfigOptionsPanel.propTypes = {
  intl: PropTypes.object,
  product: PropTypes.object,
  // data: PropTypes.object,

  systemDefinitionSlotName: PropTypes.string,
  systemDefinition: PropTypes.object,
  systemProducts: PropTypes.object,

  disabled: PropTypes.bool,
  open: PropTypes.bool,

  onToggledExcludeFromQuote: PropTypes.func,
  onToggledOption: PropTypes.func,
  onChangedProperty: PropTypes.func,
  onChangedItemProperty: PropTypes.func,
  onClose: PropTypes.func,

  onClickPropertyInfo: PropTypes.func,
  onClickOptionInfo: PropTypes.func,
  onClickProductInfo: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/configuration/options-panel/index.jsx